<script>
    export let args = [];
</script>


<i>{args[0]}</i>